module.exports = __webpack_public_path__ + "static/percent-of-profit-gif-be2ba161b06e32c97bc9ee42f9ffc74b.gif";